import { get } from "./httpClient";
import type { RootSubject } from "@/ts/interfaces/subjects/api/subjectsApiInterface";

export const getLessonsBySubject = async (
  gradeId: number
): Promise<RootSubject[]> => {
  return await get<RootSubject[]>(`lesson/grade/${gradeId}/subjects`);
};

export const subjectsApi = {
  getLessonsBySubject
};
